import React from 'react';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { IAuthCampaign } from 'pages/authentication/components/auth-campaigns/hooks/use-auth-campaign';
import UnauthRequired from 'pages/authentication/components/unauth-required';

import SignInForm from './sign-in-form';

interface ISignInFormProps {
  authCampaignExtraFields?: IAuthCampaign['extraFields'];
}

function SignIn({ authCampaignExtraFields }: ISignInFormProps) {
  useRumPageView('sign-in', 'Sign In');

  return (
    <UnauthRequired>
      <SignInForm authCampaignExtraFields={authCampaignExtraFields} />
    </UnauthRequired>
  );
}

export default SignIn;
